import React, { useState, useEffect } from 'react';
import {
  Container,
  Title,
  Text,
  Button,
  Paper,
  Group,
  Stack,
  Box,
  Avatar,
  Badge
} from '@mantine/core';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AccountDashboard from '../components/AccountDashboard';
import FundingModal from '../components/FundingModal';

function AccountPage() {
  const { user } = useAuth();
  const [fundingModalOpen, setFundingModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  // Stripe Checkout redirects back here with ?funding=success or
  // ?funding=cancelled rather than resolving in-page.
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const funding = params.get('funding');
    if (funding === 'success') {
      setRefreshKey(prev => prev + 1);
    }
    if (funding) {
      params.delete('funding');
      const newSearch = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (newSearch ? `?${newSearch}` : ''));
    }
  }, []);

  return (
    <Box style={{ background: 'linear-gradient(180deg, rgba(16,185,129,0.03) 0%, rgba(0,0,0,0) 100%)' }}>
      <Container size="xl" py="xl" px="md">
        {/* Header */}
        <Paper p="xl" radius="lg" withBorder mb="xl" style={{
          background: 'linear-gradient(135deg, rgba(16,185,129,0.05) 0%, rgba(0,0,0,0) 100%)',
          borderColor: 'rgba(16,185,129,0.2)'
        }}>
          <Group align="flex-start">
            <Box style={{ position: 'relative' }}>
              <Avatar
                src={user?.profile_picture_url}
                size={80}
                radius="xl"
                imageProps={{ 
                  style: { 
                    objectFit: 'cover',
                    width: '100%',
                    height: '100%'
                  } 
                }}
                style={{
                  border: '3px solid white',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}
              >
                {!user?.profile_picture_url && '👤'}
              </Avatar>
              <Badge
                size="sm"
                variant="dot"
                color="teal"
                style={{
                  position: 'absolute',
                  bottom: 0,
                  right: 0
                }}
              >
                Online
              </Badge>
            </Box>

            <Box style={{ flex: 1 }}>
              <Group justify="space-between" mb="xs">
                <Button
                  component={Link}
                  to="/"
                  variant="subtle"
                  size="xs"
                  leftSection="←"
                >
                  Back to Dashboard
                </Button>
                <Button
                  component={Link}
                  to="/persona-privacy"
                  variant="light"
                  size="xs"
                  leftSection="🔒"
                >
                  Persona Privacy
                </Button>
              </Group>
              <Title
                order={1}
                size="h1"
                fw={700}
                style={{
                  background: 'linear-gradient(45deg, #10b981 0%, #059669 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  marginBottom: '8px'
                }}
              >
                💰 Account Management
              </Title>
              <Text size="lg" c="dimmed">
                Manage your funding account, view transactions, and allocate budgets to groups.
              </Text>
            </Box>
          </Group>
        </Paper>

        {/* Main Content */}
        <AccountDashboard
          key={refreshKey}
          onAddFunds={() => setFundingModalOpen(true)}
        />

        {/* Funding Modal */}
        <FundingModal
          isOpen={fundingModalOpen}
          onClose={() => setFundingModalOpen(false)}
          defaultAmount={50}
        />
      </Container>
    </Box>
  );
}

export default AccountPage;
